module.exports = __webpack_public_path__ + "media/images/img_photo_m-a88e105555fc700bddd26e39388a0dcb.png";